class BabyNameFull extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';

    this.form = this.querySelector('[data-name-full-form]');
    this.results = this.querySelector('[data-name-full-results]');
    this.countOutput = this.querySelector('[data-name-full-count]');
    this.grid = this.querySelector('[data-name-full-grid]');
    this.pagination = this.querySelector('[data-name-full-pagination]');
    this.loading = this.querySelector('[data-name-full-loading]');
    this.empty = this.querySelector('[data-name-full-empty]');
    this.popularity = this.querySelector('[data-name-full-popularity]');
    this.sort = this.querySelector('[data-name-full-sort]');
    this.pageSize = Number(this.dataset.pageSize) || 10;
    this.currentPage = 1;
    this.lastName = '';
    this.matches = [];
    this.requestId = 0;
    this.names = this.buildDataset();

    if (!this.form || !this.results) return;
    this.form.addEventListener('submit', (event) => this.generate(event));
    this.popularity?.addEventListener('change', () => {
      this.currentPage = 1;
      this.render();
    });
    this.sort?.addEventListener('change', () => {
      this.currentPage = 1;
      this.render();
    });
    this.pagination?.addEventListener('click', (event) => this.changePage(event));

    ['startsWith', 'endsWith'].forEach((name) => {
      this.form.elements[name]?.addEventListener('input', (event) => {
        event.target.value = event.target.value.replace(/[^a-z]/gi, '').slice(0, 1);
      });
    });
  }

  slug(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  buildDataset() {
    const popularityOrder = `
Liam|Olivia|Noah|Emma|Oliver|Amelia|Theodore|Charlotte|Henry|Sophia|
James|Isabella|Mateo|Mia|Lucas|Evelyn|Ezra|Luna|Leo|Harper|
Mason|Layla|Arthur|Alice|Asher|Abigail|Luca|Gianna|Matteo|Maeve|
Finn|Aurora|Clara|Freya|Isla|Santiago|Axel|Dylan|Rhys|Ruby|
Violet|Hazel|Scarlett|Rose|Lily|Aria|Ariel|Wyatt|Jesse|Brooklyn|
Austin|Savannah|Beau|Georgia|Milo|Silas|Eliana|Nova|Maverick|Zayn|
Fatima|Maryam|Aarav|Mira|Imani|Zuri|Amara|Aaliyah|Poppy|Archie|
Louis|Camille|Felix|Daphne|Atlas|Athena|Kai|Leilani|Keanu|Leah|
Asha|Riya|Anaya|Ishaan|Priya|Ronan|Hana|Ren|Yuki|Bodhi|
Soren|Astrid|Callum|Zora|Amani|Nia|Linnea|Adelaide|Aylin|An
`.replace(/\s+/g, '').split('|');
    const popularityRanks = new Map(popularityOrder.map((name, position) => [name, position + 1]));
    const rows = `
Liam|boy|Irish|resolute protector|Classic;Short and sweet|2|popular
Olivia|girl|English|olive tree and peace|Classic;Elegant|4|popular
Noah|boy|Hebrew|rest and comfort|Biblical;Classic|2|popular
Emma|girl|German|whole and universal|Classic;Short and sweet|2|popular
Oliver|boy|English|olive tree and peace|Classic;Nature|3|popular
Amelia|girl|German|industrious and brave|Classic;Elegant|4|popular
Theodore|boy|Greek|gift of God|Classic;Old-fashioned|3|popular
Charlotte|girl|French|free and strong|Classic;Elegant|2|popular
Henry|boy|German|ruler of the home|Classic;Old-fashioned|2|popular
Sophia|girl|Greek|wisdom|Classic;Elegant|3|popular
James|boy|Hebrew|one who follows|Biblical;Classic|1|popular
Isabella|girl|Italian|devoted to God|Classic;Elegant|4|popular
Mateo|boy|Spanish|gift of God|Biblical;Popular-name alternatives|3|popular
Mia|girl|Italian|mine and beloved|Short and sweet;Popular-name alternatives|2|popular
Lucas|boy|Latin|bringer of light|Classic;Popular-name alternatives|2|popular
Evelyn|girl|English|wished-for child|Classic;Old-fashioned|3|popular
Ezra|boy|Hebrew|help and support|Biblical;Short and sweet|2|popular
Luna|girl|Latin|moon|Nature;Mythology|2|popular
Leo|boy|Latin|lion|Short and sweet;Cool and creative|2|popular
Harper|neutral|American|harp player|Gender-neutral;Musical|2|popular
Amara|girl|African|grace and everlasting|Elegant;Unique|3|rising
Zuri|girl|African|beautiful|Short and sweet;Unique|2|rising
Kofi|boy|African|born on Friday|Cool and creative;Unique|2|rare
Imani|neutral|African American|faith|Gender-neutral;Elegant|3|rising
DeShawn|boy|African American|God is gracious|Cool and creative;Unique|2|rare
Aaliyah|girl|African American|exalted and rising|Elegant;Popular-name alternatives|3|rising
Mason|boy|American|stone worker|Classic;Southern|2|popular
Kennedy|neutral|American|helmeted chief|Gender-neutral;Places|3|rising
Sawyer|neutral|American|woodcutter|Gender-neutral;Wild West|2|rising
Ahyoka|girl|American Indian|she brought happiness|Nature;Unique|3|rare
Kiona|girl|American Indian|brown hills|Nature;Places|3|rare
Takoda|boy|American Indian|friend to everyone|Nature;Unique|3|rare
Poppy|girl|British|red flower|Flowers;Color-inspired|2|rising
Archie|boy|British|genuine and bold|Old-fashioned;Short and sweet|2|rising
Imogen|girl|British|maiden|Shakespeare;Elegant|3|rare
Layla|girl|Arabic|night beauty|Elegant;Nature|2|popular
Omar|boy|Arabic|flourishing and long-lived|Classic;Short and sweet|2|rising
Noor|neutral|Arabic|light|Gender-neutral;Short and sweet|1|rising
Martha|girl|Aramaic|lady of the house|Biblical;Old-fashioned|2|rare
Thomas|boy|Aramaic|twin|Biblical;Classic|2|popular
Talia|girl|Aramaic|gentle dew from heaven|Nature;Elegant|3|rising
Ani|girl|Armenian|beautiful and bright|Short and sweet;Elegant|2|rare
Aram|boy|Armenian|high land|Places;Unique|2|rare
Narek|boy|Armenian|from Narek|Places;Unique|2|rare
Ane|girl|Basque|grace|Short and sweet;Classic|2|rare
Unai|boy|Basque|shepherd|Nature;Unique|2|rare
Aitor|boy|Basque|good father|Classic;Unique|2|rare
Brianna|girl|Celtic|strong and noble|Classic;Elegant|3|rising
Tristan|boy|Celtic|bold and legendary|Mythology;Classic|2|rising
Rhiannon|girl|Celtic|great queen|Mythology;Elegant|3|rare
Amina|girl|Chechen|trustworthy and faithful|Elegant;Classic|3|rising
Adam|boy|Chechen|earth and humanity|Biblical;Short and sweet|2|popular
Khamzat|boy|Chechen|steadfast|Strong;Unique|2|rare
Mei|girl|Chinese|beautiful plum blossom|Flowers;Short and sweet|1|rising
Jian|neutral|Chinese|healthy and strong|Gender-neutral;Short and sweet|1|rare
Lian|neutral|Chinese|graceful lotus|Gender-neutral;Flowers|2|rare
Bram|boy|Dutch|father of multitudes|Old-fashioned;Short and sweet|1|rare
Femke|girl|Dutch|peace|Unique;Short and sweet|2|rare
Daan|boy|Dutch|God is my judge|Biblical;Short and sweet|1|rare
Cleo|girl|Egyptian|glory of the father|Elegant;Short and sweet|2|rising
Nefertari|girl|Egyptian|beautiful companion|Mythology;Unique|4|rare
Amun|boy|Egyptian|the hidden one|Mythology;Unique|2|rare
Arthur|boy|English|noble and courageous|Classic;Old-fashioned|2|popular
Alice|girl|English|noble|Classic;Old-fashioned|2|popular
Rowan|neutral|English|little red tree|Gender-neutral;Nature|2|rising
Semhar|girl|Eritrean|joy and celebration|Unique;Elegant|2|rare
Nahom|boy|Eritrean|comfort|Biblical;Unique|2|rare
Senait|girl|Eritrean|good fortune|Elegant;Unique|2|rare
Tala|girl|Filipino|bright star|Nature;Short and sweet|2|rising
Bayani|boy|Filipino|hero|Cool and creative;Unique|3|rare
Ligaya|girl|Filipino|joy|Elegant;Unique|3|rare
Camille|neutral|French|young ceremonial attendant|Gender-neutral;Elegant|2|rising
Louis|boy|French|renowned warrior|Classic;Elegant|2|popular
Juliette|girl|French|youthful|Shakespeare;Elegant|3|rising
Saoirse|girl|Gaelic|freedom|Cool and creative;Unique|2|rising
Niamh|girl|Gaelic|bright and radiant|Mythology;Short and sweet|1|rare
Cian|boy|Gaelic|ancient and enduring|Short and sweet;Unique|2|rare
Felix|boy|German|happy and fortunate|Classic;Short and sweet|2|rising
Greta|girl|German|pearl|Old-fashioned;Short and sweet|2|rising
Otto|boy|German|wealth and prosperity|Old-fashioned;Short and sweet|2|rising
Kwame|boy|Ghanaian|born on Saturday|Unique;Cool and creative|2|rare
Akua|girl|Ghanaian|born on Wednesday|Unique;Short and sweet|3|rare
Ama|girl|Ghanaian|born on Saturday|Short and sweet;Unique|2|rare
Daphne|girl|Greek|laurel tree|Mythology;Nature|2|rising
Atlas|boy|Greek|bearer of the heavens|Mythology;Cool and creative|2|rising
Athena|girl|Greek|goddess of wisdom|Mythology;Elegant|3|rising
Kai|neutral|Hawaiian|sea|Gender-neutral;Nature|1|popular
Leilani|girl|Hawaiian|heavenly flower|Flowers;Elegant|3|rising
Keanu|boy|Hawaiian|cool mountain breeze|Nature;Unique|3|rising
Abigail|girl|Hebrew|source of joy|Biblical;Classic|3|popular
Leah|girl|Hebrew|delicate and weary|Biblical;Short and sweet|2|popular
Asher|boy|Hebrew|happy and blessed|Biblical;Popular-name alternatives|2|popular
Asha|girl|Hindi|hope|Short and sweet;Elegant|2|rising
Riya|girl|Hindi|singer and graceful|Musical;Short and sweet|2|rising
Prem|boy|Hindi|love|Short and sweet;Unique|1|rare
Aarav|boy|Hindu|peaceful|Elegant;Popular-name alternatives|2|popular
Anaya|girl|Hindu|caring and protected|Elegant;Unique|3|rising
Ishaan|boy|Hindu|sun and lord|Nature;Mythology|2|rising
Zoltan|boy|Hungarian|life and ruler|Strong;Unique|2|rare
Ilona|girl|Hungarian|shining light|Elegant;Unique|3|rare
Eszter|girl|Hungarian|star|Nature;Unique|2|rare
Arjun|boy|Indian|bright and shining|Mythology;Strong|2|rising
Priya|girl|Indian|beloved|Elegant;Short and sweet|2|rising
Mira|girl|Indian|wonder and ocean|Nature;Short and sweet|2|popular
Maeve|girl|Irish|intoxicating queen|Mythology;Short and sweet|1|popular
Finn|boy|Irish|fair and bright|Short and sweet;Classic|1|popular
Ronan|boy|Irish|little seal|Nature;Classic|2|rising
Luca|neutral|Italian|bringer of light|Gender-neutral;Popular-name alternatives|2|popular
Gianna|girl|Italian|God is gracious|Elegant;Popular-name alternatives|3|popular
Matteo|boy|Italian|gift of God|Classic;Popular-name alternatives|3|popular
Hana|girl|Japanese|flower|Flowers;Short and sweet|2|rising
Ren|neutral|Japanese|lotus and love|Gender-neutral;Short and sweet|1|rising
Yuki|neutral|Japanese|snow and happiness|Gender-neutral;Nature|2|rising
Minji|girl|Korean|bright wisdom|Elegant;Unique|2|rare
Joon|boy|Korean|talented and handsome|Short and sweet;Unique|1|rare
Bora|girl|Korean|purple|Color-inspired;Short and sweet|2|rare
Aurora|girl|Latin|dawn|Mythology;Nature|3|popular
Clara|girl|Latin|bright and clear|Classic;Elegant|2|popular
Maximus|boy|Latin|greatest|Strong;Classic|3|rising
Aroha|girl|Maori|love and compassion|Nature;Unique|3|rare
Manaia|neutral|Maori|spiritual guardian|Gender-neutral;Mythology|3|rare
Nikau|boy|Maori|palm tree|Nature;Unique|2|rare
Fatima|girl|Muslim|captivating and one who abstains|Classic;Elegant|3|popular
Zayn|boy|Muslim|beauty and grace|Short and sweet;Cool and creative|1|popular
Maryam|girl|Muslim|beloved and pure|Biblical;Classic|2|popular
Winona|girl|Native American|firstborn daughter|Nature;Classic|3|rising
Dakota|neutral|Native American|friend and ally|Gender-neutral;Places|3|popular
Cheyenne|neutral|Native American|people of a different language|Gender-neutral;Places|2|rising
Chiamaka|girl|Nigerian|God is beautiful|Elegant;Unique|4|rare
Obinna|boy|Nigerian|father's heart|Classic;Unique|3|rare
Adaeze|girl|Nigerian|daughter of a king|Elegant;Unique|3|rare
Darius|boy|Persian|possessing goodness|Classic;Strong|3|rising
Shirin|girl|Persian|sweet and charming|Elegant;Unique|2|rare
Cyrus|boy|Persian|sun and throne|Classic;Strong|2|rising
Zofia|girl|Polish|wisdom|Classic;Popular-name alternatives|3|rising
Jan|neutral|Polish|God is gracious|Gender-neutral;Short and sweet|1|rare
Aniela|girl|Polish|angel and messenger|Elegant;Unique|3|rare
Moana|girl|Polynesian|ocean|Disney characters;Nature|3|popular
Maui|boy|Polynesian|island and legendary hero|Disney characters;Mythology|2|rising
Kalani|neutral|Polynesian|the heavens|Gender-neutral;Nature|3|rising
Simran|neutral|Punjabi|meditation and remembrance|Gender-neutral;Elegant|2|rare
Gurpreet|neutral|Punjabi|love of the teacher|Gender-neutral;Unique|2|rare
Navdeep|neutral|Punjabi|new light|Gender-neutral;Unique|2|rare
Anastasia|girl|Russian|resurrection|Elegant;Classic|4|rising
Nikolai|boy|Russian|victory of the people|Classic;Strong|3|rising
Mila|girl|Russian|gracious and dear|Short and sweet;Popular-name alternatives|2|popular
Bodhi|neutral|Sanskrit|awakening and enlightenment|Gender-neutral;Nature|2|popular
Indira|girl|Sanskrit|beauty and splendor|Elegant;Mythology|3|rising
Kiran|neutral|Sanskrit|ray of light|Gender-neutral;Nature|2|rising
Freya|girl|Scandinavian|goddess of love|Mythology;Elegant|2|popular
Soren|boy|Scandinavian|stern and strong|Classic;Cool and creative|2|rising
Astrid|girl|Scandinavian|divinely beautiful|Elegant;Old-fashioned|2|rising
Isla|girl|Scottish|island|Nature;Places|2|popular
Callum|boy|Scottish|dove|Nature;Classic|2|rising
Ewan|boy|Scottish|born of the yew tree|Nature;Unique|2|rare
Zora|girl|Slavic|dawn|Nature;Short and sweet|2|rising
Casimir|boy|Slavic|proclaimer of peace|Classic;Unique|3|rare
Danica|girl|Slavic|morning star|Nature;Unique|3|rare
Santiago|boy|Spanish|Saint James|Biblical;Places|4|popular
Alba|girl|Spanish|dawn and white|Color-inspired;Short and sweet|2|rising
Rio|neutral|Spanish|river|Gender-neutral;Nature|2|rising
Nia|girl|Swahili|purpose|Short and sweet;Elegant|2|rising
Jabari|boy|Swahili|brave|Strong;Unique|3|rising
Amani|neutral|Swahili|peace|Gender-neutral;Elegant|3|rising
Linnea|girl|Swedish|twinflower|Flowers;Elegant|3|rising
Axel|boy|Swedish|father of peace|Cool and creative;Short and sweet|2|popular
Freja|girl|Swedish|lady and goddess of love|Mythology;Popular-name alternatives|2|rising
Adelaide|girl|Teutonic|noble natured|Old-fashioned;Elegant|3|rising
Bernard|boy|Teutonic|brave bear|Old-fashioned;Strong|2|rare
Conrad|boy|Teutonic|brave counsel|Old-fashioned;Strong|2|rare
Sione|boy|Tongan|God is gracious|Biblical;Unique|3|rare
Mele|girl|Tongan|song|Musical;Short and sweet|2|rare
Latu|neutral|Tongan|chief|Gender-neutral;Unique|2|rare
Aylin|girl|Turkish|moon halo|Nature;Elegant|2|rising
Emir|boy|Turkish|prince and commander|Strong;Short and sweet|2|rising
Deniz|neutral|Turkish|sea|Gender-neutral;Nature|2|rising
Kato|boy|Ugandan|second-born twin|Classic;Short and sweet|2|rare
Nakato|girl|Ugandan|second-born female twin|Unique;Classic|3|rare
Wasswa|boy|Ugandan|first-born male twin|Unique;Classic|2|rare
An|neutral|Vietnamese|peace and safety|Gender-neutral;Short and sweet|1|rising
Linh|neutral|Vietnamese|spirit and soul|Gender-neutral;Short and sweet|1|rising
Minh|neutral|Vietnamese|bright and clever|Gender-neutral;Short and sweet|1|rising
Dylan|neutral|Welsh|son of the sea|Gender-neutral;Nature|2|popular
Carys|girl|Welsh|love|Elegant;Unique|2|rising
Rhys|boy|Welsh|enthusiasm|Short and sweet;Classic|1|popular
Ayomide|neutral|Yoruban|my joy has arrived|Gender-neutral;Elegant|4|rare
Ife|neutral|Yoruban|love|Gender-neutral;Short and sweet|2|rare
Temitope|neutral|Yoruban|worthy of gratitude|Gender-neutral;Unique|4|rare
Ruby|girl|English|red precious stone|Color-inspired;Classic|2|popular
Violet|girl|English|purple flower|Color-inspired;Flowers|3|popular
Hazel|girl|English|hazelnut tree and warm brown|Color-inspired;Nature|2|popular
Indigo|neutral|Greek|deep blue dye|Color-inspired;Gender-neutral|3|rising
Scarlett|girl|English|vivid red|Color-inspired;Elegant|2|popular
Rose|girl|Latin|rose flower|Flowers;Classic|1|popular
Lily|girl|English|pure lily flower|Flowers;Short and sweet|2|popular
Dahlia|girl|Swedish|dahlia flower|Flowers;Elegant|3|rising
Iris|girl|Greek|rainbow and iris flower|Flowers;Mythology|2|popular
Flora|girl|Latin|flower and spring|Flowers;Old-fashioned|2|rising
Aria|girl|Italian|melody and air|Musical;Elegant|3|popular
Lyric|neutral|English|words of a song|Musical;Gender-neutral|2|rising
Cadence|girl|Latin|rhythm|Musical;Cool and creative|2|rising
Melody|girl|Greek|song and music|Musical;Elegant|3|rising
Reed|boy|English|red-haired and woodwind reed|Musical;Nature|1|rising
Ariel|neutral|Hebrew|lion of God|Disney characters;Gender-neutral|3|popular
Belle|girl|French|beautiful|Disney characters;Short and sweet|1|rising
Flynn|boy|Irish|red-haired|Disney characters;Cool and creative|1|rising
Tiana|girl|Latin|princess and follower of Christ|Disney characters;Elegant|3|rising
Nala|girl|African|beloved and successful|Disney characters;Short and sweet|2|rising
Ophelia|girl|Greek|helper|Shakespeare;Elegant|4|rising
Viola|girl|Latin|violet flower|Shakespeare;Flowers|3|rising
Romeo|boy|Italian|pilgrim to Rome|Shakespeare;Places|3|rising
Rosalind|girl|German|gentle horse and beautiful rose|Shakespeare;Elegant|3|rare
Orlando|boy|Italian|famous throughout the land|Shakespeare;Places|3|rising
Wyatt|boy|English|brave in war|Wild West;Strong|2|popular
Jesse|neutral|Hebrew|gift|Wild West;Gender-neutral|2|popular
Boone|boy|French|blessing|Wild West;Southern|1|rising
Annie|girl|English|grace|Wild West;Old-fashioned|2|rising
Colt|boy|English|young horse|Wild West;Nature|1|rising
Brooklyn|neutral|American|New York borough|Places;Gender-neutral|2|popular
Austin|neutral|American|great and magnificent|Places;Gender-neutral|2|popular
Paris|neutral|Greek|city of light|Places;Gender-neutral|2|rising
Savannah|girl|Spanish|open grassy plain|Places;Southern|3|popular
Siena|girl|Italian|from the Tuscan city|Places;Color-inspired|3|rising
Beau|boy|French|handsome|Southern;Short and sweet|1|popular
Magnolia|girl|French|magnolia flower|Southern;Flowers|4|rising
Georgia|girl|Greek|farmer and earth worker|Southern;Places|2|popular
Otis|boy|German|wealthy|Hipster;Old-fashioned|2|rising
Juniper|girl|Latin|evergreen tree|Hipster;Nature|3|rising
Milo|boy|German|merciful and soldier|Hipster;Short and sweet|2|popular
Mabel|girl|Latin|lovable|Old-fashioned;Short and sweet|2|rising
Edith|girl|English|prosperous in war|Old-fashioned;Classic|2|rising
Silas|boy|Latin|of the forest|Biblical;Nature|2|popular
Eliana|girl|Hebrew|God has answered|Popular-name alternatives;Elegant|4|popular
Livia|girl|Latin|olive and blue|Popular-name alternatives;Color-inspired|3|rising
Orson|boy|Latin|bear cub|Popular-name alternatives;Nature|2|rising
Nova|girl|Latin|new star|Cool and creative;Nature|2|popular
Maverick|boy|American|independent minded|Cool and creative;Wild West|3|popular
Echo|neutral|Greek|reflected sound|Cool and creative;Mythology|2|rising
Sunday|neutral|English|born on Sunday|Unique;Gender-neutral|2|rare
Zephyr|neutral|Greek|west wind|Unique;Nature|2|rising
Promise|neutral|American|vow and hope|Unique;Gender-neutral|2|rare
`.trim();

    return rows.split('\n').map((row) => {
      const [name, gender, origin, meaning, themes, syllables, tier] = row.split('|');
      return {
        name,
        gender,
        origin,
        originSlug: this.slug(origin),
        meaning,
        themes: themes.split(';'),
        themeSlugs: themes.split(';').map((theme) => this.slug(theme)),
        syllables: Number(syllables),
        tier,
        popularityRank: popularityRanks.get(name) || null,
      };
    });
  }

  generate(event) {
    event.preventDefault();
    const data = new FormData(this.form);
    const gender = String(data.get('gender') || 'any');
    const startsWith = String(data.get('startsWith') || '').trim().toLowerCase();
    const endsWith = String(data.get('endsWith') || '').trim().toLowerCase();
    const syllables = Number(data.get('nameLength') || 0);
    const theme = String(data.get('theme') || 'any');
    const origin = String(data.get('origin') || 'any');
    const meaningTokens = String(data.get('meaning') || '')
      .toLowerCase()
      .split(/[,;/]+|\s+/)
      .map((token) => token.trim())
      .filter((token) => token.length > 1);
    this.lastName = String(data.get('lastName') || '').trim();
    this.currentPage = 1;

    this.matches = this.names.filter((item) => {
      const searchable = `${item.name} ${item.meaning} ${item.themes.join(' ')}`.toLowerCase();
      return (gender === 'any' || (gender === 'both'
        ? item.gender === 'boy' || item.gender === 'girl'
        : item.gender === gender))
        && (!startsWith || item.name.toLowerCase().startsWith(startsWith))
        && (!endsWith || item.name.toLowerCase().endsWith(endsWith))
        && (!syllables || item.syllables === syllables)
        && (theme === 'any' || item.themeSlugs.includes(theme))
        && (origin === 'any' || item.originSlug === origin)
        && (!meaningTokens.length || meaningTokens.some((token) => searchable.includes(token)));
    });

    const requestId = ++this.requestId;
    this.results.hidden = false;
    this.results.setAttribute('aria-busy', 'true');
    this.loading.hidden = false;
    this.grid.hidden = true;
    this.empty.hidden = true;
    this.pagination.replaceChildren();
    this.form.classList.add('is-loading');

    window.setTimeout(() => {
      if (requestId !== this.requestId) return;
      this.loading.hidden = true;
      this.grid.hidden = false;
      this.form.classList.remove('is-loading');
      this.results.setAttribute('aria-busy', 'false');
      this.render();
      this.results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }, 450);
  }

  filteredAndSorted() {
    const popularity = this.popularity?.value || 'all';
    const sorting = this.sort?.value || 'popular';
    const filtered = this.matches.filter((item) => {
      if (popularity === 'top50') return item.popularityRank !== null && item.popularityRank <= 50;
      if (popularity === 'top100') return item.popularityRank !== null && item.popularityRank <= 100;
      if (popularity === 'exclude50') return item.popularityRank === null || item.popularityRank > 50;
      if (popularity === 'exclude100') return item.popularityRank === null || item.popularityRank > 100;
      return true;
    });

    filtered.sort((a, b) => {
      if (sorting === 'az') return a.name.localeCompare(b.name);
      if (sorting === 'za') return b.name.localeCompare(a.name);
      const aRank = a.popularityRank ?? Number.POSITIVE_INFINITY;
      const bRank = b.popularityRank ?? Number.POSITIVE_INFINITY;
      if (aRank !== bRank) return aRank - bRank;
      const tierWeight = { popular: 0, rising: 1, rare: 2 };
      return tierWeight[a.tier] - tierWeight[b.tier] || a.name.localeCompare(b.name);
    });
    return filtered;
  }

  render() {
    const names = this.filteredAndSorted();
    const totalPages = Math.max(1, Math.ceil(names.length / this.pageSize));
    this.currentPage = Math.min(this.currentPage, totalPages);
    const start = (this.currentPage - 1) * this.pageSize;
    const pageNames = names.slice(start, start + this.pageSize);

    this.countOutput.textContent = `Here are ${names.length.toLocaleString('en-US')} baby name ideas that should work for you and your baby:`;
    this.grid.replaceChildren();
    this.empty.hidden = names.length > 0;
    this.grid.hidden = names.length === 0;

    pageNames.forEach((item) => this.grid.append(this.createCard(item)));
    this.renderPagination(totalPages, names.length);
  }

  createCard(item) {
    const card = document.createElement('article');
    const title = document.createElement('h4');
    const meaning = document.createElement('p');
    const meta = document.createElement('div');
    const origin = document.createElement('span');
    const theme = document.createElement('span');
    const popularity = document.createElement('span');

    card.className = 'name-full__card';
    title.textContent = this.lastName ? `${item.name} ${this.lastName}` : item.name;
    meaning.textContent = item.meaning.charAt(0).toUpperCase() + item.meaning.slice(1);
    origin.textContent = item.origin;
    theme.textContent = item.themes[0];
    popularity.textContent = item.tier === 'popular' ? 'Popular' : item.tier === 'rising' ? 'Rising' : 'Rare';
    popularity.className = `name-full__tier name-full__tier--${item.tier}`;
    meta.className = 'name-full__meta';
    meta.append(origin, theme, popularity);
    card.append(title, meaning, meta);
    return card;
  }

  renderPagination(totalPages, totalNames) {
    this.pagination.replaceChildren();
    if (totalNames <= this.pageSize) return;

    this.pagination.append(this.pageButton('Previous', this.currentPage - 1, this.currentPage === 1, 'name-full__page-arrow'));
    const pages = this.pageWindow(totalPages);
    let previousPage = 0;
    pages.forEach((page) => {
      if (previousPage && page - previousPage > 1) {
        const ellipsis = document.createElement('span');
        ellipsis.textContent = '...';
        ellipsis.setAttribute('aria-hidden', 'true');
        this.pagination.append(ellipsis);
      }
      const button = this.pageButton(String(page), page, false, 'name-full__page-number');
      if (page === this.currentPage) {
        button.classList.add('is-current');
        button.setAttribute('aria-current', 'page');
      }
      this.pagination.append(button);
      previousPage = page;
    });
    this.pagination.append(this.pageButton('Next', this.currentPage + 1, this.currentPage === totalPages, 'name-full__page-arrow'));
  }

  pageWindow(totalPages) {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
    const pages = new Set([1, totalPages]);
    for (let page = Math.max(2, this.currentPage - 1); page <= Math.min(totalPages - 1, this.currentPage + 1); page += 1) {
      pages.add(page);
    }
    return Array.from(pages).sort((a, b) => a - b);
  }

  pageButton(label, page, disabled, className) {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.dataset.page = String(page);
    button.className = className;
    button.disabled = disabled;
    button.setAttribute('aria-label', label.length > 2 ? `${label} page` : `Page ${label}`);
    return button;
  }

  changePage(event) {
    const button = event.target.closest('button[data-page]');
    if (!button || button.disabled) return;
    this.currentPage = Number(button.dataset.page);
    this.render();
    this.results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
}

if (!customElements.get('baby-name-full')) {
  customElements.define('baby-name-full', BabyNameFull);
}
